import React from "react";
import { db } from "../../firebase";
import { doc, deleteDoc } from "firebase/firestore";

export default function ExperiencesAdminSection({
  lang,
  experiences,
  openAddExpModal,
  openEditExpModal,
  setExperiences
}) {
  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "experiences", id));
    setExperiences(experiences.filter(e => e.id !== id));
  };

  return (
    <section className="section">
      <h2 className="sectionTitle">Experiences ({lang})</h2>
      <button className="button" style={{ marginBottom: 16 }} onClick={openAddExpModal}>
        Agregar experiencia
      </button>
      <ul className="list listColumn">
        {experiences.map(exp => (
          <li key={exp.id} className="listItem" style={{ justifyContent: "space-between" }}>
            <div>
              <b>{exp.title}</b> - {exp.description}
              <br />
              <span style={{ fontSize: "0.95em", color: "#235390" }}>
                Skills: {Array.isArray(exp.skills)
                  ? exp.skills.map(t => t.name).join(", ")
                  : ""}
              </span>
            </div>
            <div>
              <button className="iconBtn" title="Editar" onClick={() => openEditExpModal(exp)}>
                ✏️
              </button>
              <button
                onClick={() => handleDelete(exp.id)}
                className="buttonDanger"
              >
                X
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}